import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { CircleFigureComponent } from "./circle/circle.component";

@NgModule({
	imports: [CommonModule],
	declarations: [CircleFigureComponent],
	exports: [CircleFigureComponent],
})
export class FigureModule {}
